import * as v from 'valibot';

export const SuccessStatusSchema = v.union([
  v.literal('passed'),
  v.literal('failed'),
  v.literal('unknown'),
]);

export type TSuccessStatus = v.Output<typeof SuccessStatusSchema>;
